export default __webpack_public_path__ + "static/23-3347e683c2d55fab611f1d86fb50f110.jpg";